import { computed, inject, Injectable } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { AppConfigService } from '../config/app-config.service'
import { ICON_CATEGORIES } from './icon-categories'

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private iconRegistry = inject(MatIconRegistry)
  private domSanitizer = inject(DomSanitizer)

  configService = inject(AppConfigService)
  materialIconsClass = computed(() => this.configService.config()?.materialIconsClass ?? 'material-symbols-outlined-fill')

  registerIcons(): void {
    const icons = Object.values(ICON_CATEGORIES).flat()
    this.iconRegistry.setDefaultFontSetClass(this.materialIconsClass())

    icons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(icon.name, this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path))
    })
  }
}
